module.exports = __webpack_public_path__ + "23401809e478904a23dcb6e211ef2056.svg";